import { IonContent, IonFooter, IonModal, IonSpinner } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Button } from '~/shared/ui/Buttons'
import { useImgLoad } from '~/shared/ui/Img'
import { useModal } from '~/shared/ui/Modal'
import { Zoom } from '~/shared/ui/Zoom'
import { IonAvatar, IonToolbarFooter, ModalImageWrapper } from './styled'

type AvatarProps = {
  url?: string
}

export function Avatar({ url }: AvatarProps) {
  const { t } = useTranslation()

  const { isModalShow, closeModal, openModal } = useModal()
  const { imageUrl, isLoading } = useImgLoad(url)

  const src = imageUrl || '/images/avatar.svg'

  const handleWarning = () => {
    snackbarEnqueued({
      messageI18n: 'alert.driver photo not uploaded to the system',
      variant: 'warning' as const,
    })
  }

  return (
    <>
      <IonAvatar slot='start' onClick={imageUrl ? openModal : handleWarning}>
        {isLoading && (
          <IonSpinner name='bubbles' data-testid='circular-progress' />
        )}
        {!isLoading && <img src={src} alt='' />}
      </IonAvatar>
      <IonModal
        isOpen={isModalShow}
        keepContentsMounted={false}
        onWillDismiss={closeModal}
      >
        <IonContent
          style={{
            '--overscroll-behavior': 'none',
            '--webkit-overscroll-behavior': 'none',
            '--overflow': 'hidden',
          }}
        >
          <ModalImageWrapper>
            {isModalShow && (
              <Zoom>
                <img src={src} alt='' />
              </Zoom>
            )}
          </ModalImageWrapper>
        </IonContent>

        <IonFooter>
          <IonToolbarFooter>
            <Button
              slot='end'
              uppercase
              variant='textBlue'
              onClick={closeModal}
            >
              {t('button.close')}
            </Button>
          </IonToolbarFooter>
        </IonFooter>
      </IonModal>
    </>
  )
}
